import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3704b721")

_pushScopeId("data-v-3704b721")
const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_ExpandableClass = _resolveComponent("ExpandableClass")

  return (_ctx.waiting)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_LoadingSpinner)
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_2, [
        _createVNode("ul", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.classes, (c) => {
            return (_openBlock(), _createBlock(_component_ExpandableClass, {
              key: c.iri,
              classData: c,
              modelValue: _ctx.selectedClass,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedClass = $event)),
              onHierarchyUpdate: _ctx.passHierarchyUpdate,
              depth: 0
            }, null, 8, ["classData", "modelValue", "onHierarchyUpdate"]))
          }), 128))
        ])
      ]))
})